// Edit the text of each section here. Paragraphs are separate strings.
export const PHILOSOPHY_GROUPS = [
  {
    id: "modes",
    title: "The Three Modes",
    sections: [
      {
        id: "meditation",
        title: "Meditation",
        paragraphs: [
          "A journey of sound along the central channel. Press Begin and each of the seven chakras lights in turn, sounding its own frequency while the Seed of Life takes on that chakra's colour.",
          "Choose Ascend to rise from the Root to the Crown, drawing energy upward toward spirit, or Descend to travel from the Crown down to the Root, bringing that light back into the body and grounding it.",
          "Choose how long each chakra sounds (6, 12 or 20 seconds), the sound itself (Pure Tone, Singing Bowl or Binaural Theta) and the octave (Low, Mid or High). Binaural Theta works best with headphones.",
          "Tap any single chakra to rest in its tone for one cycle — ideal when one centre is calling for attention.",
        ],
      },
      {
        id: "healing",
        title: "Healing",
        paragraphs: [
          "Box breathing in tune with the chakras. Each breath has four even sides — Inhale, Hold, Exhale, Hold — while the chakra's tone sounds beneath you.",
          "Follow the ring around the Seed of Life: it widens to the outer Flower of Life as you breathe in, rests while you hold, and returns to the centre circle as you breathe out. A soft chime marks every change, so you can practise with your eyes closed; tap Breath Chimes to turn them off.",
          "Choose 4, 8 or 12 seconds per side, plus the sound and octave. Choose Ascend to breathe from the Root up to the Crown, or Descend to breathe from the Crown down to the Root, then press Begin for one breath with each of the seven chakras — or tap a single chakra for one breath with it.",
        ],
      },
      {
        id: "attune",
        title: "Attune",
        paragraphs: [
          "A voice game for tuning yourself to each chakra. Allow the microphone, then hum or sing — the app listens and shows the note you are making and how close you are to the chakra's tone.",
          "The meter and arrows guide you: sing higher or lower until the marker settles in the centre, then hold it steady for a moment to match. Any octave counts, so sing wherever your voice is comfortable, and choose Low, Mid or High for the reference tone.",
          "Tap any chakra for free practice. Press Attune to climb from Root to Crown (or choose Descend to travel from Crown down to Root), or Random to jump between chakras: the app sounds a sequence, you sing it back, and each round adds one more note. Turn on the Shruti drone for a steady tone to sing against.",
        ],
      },
    ],
  },
  {
    id: "philosophy",
    title: "The Philosophy",
    sections: [
      { id: "breath", title: "Breath", paragraphs: [] },
      { id: "sound", title: "Sound & Frequency", paragraphs: [] },
      { id: "chakras", title: "The Chakras", paragraphs: [] },
      { id: "geometry", title: "Sacred Geometry", paragraphs: [] },
      { id: "stars", title: "The Stars", paragraphs: [] },
    ],
  },
];
